var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeather(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.034,
    height: 25.463,
    viewBox: "0 0 40.034 25.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-weather-1021111",
    transform: "translate(-168.35 -165.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M287.233,170.318h-.394a7.925,7.925,0,0,0-14.958.123,7.971,7.971,0,0,0-6.141,5.339,1.384,1.384,0,1,0,2.631.86,5.17,5.17,0,0,1,4.667-3.549,1.384,1.384,0,0,0,1.293-1.112,5.172,5.172,0,0,1,10.136.11,1.383,1.383,0,0,0,1.661,1.106,5.171,5.171,0,1,1,1.461,10.181h-8.649a1.383,1.383,0,1,0,0,2.766h8.727a1.4,1.4,0,0,0,.362-.045,7.925,7.925,0,0,0-.8-15.779Z",
    transform: "translate(-86.536 0)",
    fill: "#bec4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M208.993,293.909h18.32a1.383,1.383,0,0,0,0-2.767h-18.32a1.383,1.383,0,0,0,0,2.767Z",
    transform: "translate(-34.909 -112.097)",
    fill: "#bec4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M250.943,369.89h-18.32a1.383,1.383,0,0,0,0,2.767h18.32a1.383,1.383,0,0,0,0-2.767Z",
    transform: "translate(-55.921 -182.118)",
    fill: "#bec4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M190.3,331.9a1.383,1.383,0,0,0-1.383-1.383h-19.18a1.383,1.383,0,0,0,0,2.767h19.2A1.383,1.383,0,0,0,190.3,331.9Z",
    transform: "translate(0 -147.108)",
    fill: "#bec4de"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeather);
export default __webpack_public_path__ + "static/media/weather.829522d637cc2ecb36f391512b9a1ed1.svg";
export { ForwardRef as ReactComponent };